import styles from "./liveGame.module.css";

const liveGameStyles={
    outer_container: `flex w-full justify-between ${styles.outer_container} gap-[10px] py-[10px] flex-col
                        screen-500:py-[30px]
                        lg:flex-row lg:gap-0
    `,
    section: `flex flex-col gap-[10px] items-center`,
    left_container: `flex flex-col gap-[25px] items-center justify-center`,
    fullScreenContainer: `!py-0 container ${styles.fullScreenContainer}`,
}
export {liveGameStyles};